// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"a0d53fb3","82":"93788613","132":"6ddb7419","553":"afc9601a","719":"f35e9a4c","829":"f3736f49","865":"601fc0f1","919":"f8a1da94","949":"58892a82"}[chunkId] + ".chunk.js";
};